<div [formGroup]="form">

    <div class="row">
        <div class="col-md-12">

            <div class="row">
                <!--Exportador-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedExportador = !isCollapsedExportador" [attr.aria-expanded]="!isCollapsedExportador" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Exportador
                                <i *ngIf="isCollapsedExportador" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedExportador" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedExportador" [ngbCollapse]="isCollapsedExportador">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombreExportador">Nombre</label>
                                        <input formControlName="NombreExportador" name="NombreExportador" title="" class="form-control" id="NombreExportador" type="text" value="" [ngClass]="displayFieldCss('NombreExportador')" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisExportador">País</label>
                                        <input formControlName="PaisExportador" name="PaisExportador" title="" class="form-control" id="PaisExportador" type="text" value="" [ngClass]="displayFieldCss('PaisExportador')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Importador-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedImportador = !isCollapsedImportador" [attr.aria-expanded]="!isCollapsedImportador" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Importador
                                <i *ngIf="isCollapsedImportador" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedImportador" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedImportador" [ngbCollapse]="isCollapsedImportador">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombreImportador">Nombre</label>
                                        <input formControlName="NombreImportador" name="NombreImportador" title="" class="form-control" id="NombreImportador" type="text" value="" [ngClass]="displayFieldCss('NombreImportador')" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisImportador">País</label>
                                        <input formControlName="PaisImportador" name="PaisImportador" title="" class="form-control" id="PaisImportador" type="text" value="" [ngClass]="displayFieldCss('PaisImportador')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--Referencia del documento aduanero-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDocAduanero = !isCollapsedDocAduanero" [attr.aria-expanded]="!isCollapsedDocAduanero" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Documento aduanero
                                <i *ngIf="isCollapsedDocAduanero" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDocAduanero" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedDocAduanero" [ngbCollapse]="isCollapsedDocAduanero">
                                <div class="row">

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="RefDocAduanero">Referencia</label>
                                        <input formControlName="RefDocAduanero" name="RefDocAduanero" title="" class="form-control" id="RefDocAduanero" type="text" value="" [ngClass]="displayFieldCss('RefDocAduanero')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Referencia del CHEDPP-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCHEDPP = !isCollapsedCHEDPP" [attr.aria-expanded]="!isCollapsedCHEDPP" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> CHEDPP
                                <i *ngIf="isCollapsedCHEDPP" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCHEDPP" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCHEDPP" [ngbCollapse]="isCollapsedCHEDPP">
                                <div class="row">

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="Referencia">Referencia</label>
                                        <input formControlName="Referencia" name="Referencia" title="" class="form-control" id="Referencia" type="text" value="" [ngClass]="displayFieldCss('Referencia')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--PCF-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedPCF = !isCollapsedPCF" [attr.aria-expanded]="!isCollapsedPCF" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Puesto de Control Fronterizo
                                <i *ngIf="isCollapsedPCF" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedPCF" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedPCF" [ngbCollapse]="isCollapsedPCF">
                                <div class="row">

                                    <!--<div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombrePCF">Nombre (PCF)</label>
                                        <input formControlName="NombrePCF" name="NombrePCF" title="" class="form-control" id="NombrePCF" type="text" value="" [ngClass]="displayFieldCss('NombrePCF')" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisPCF">País (PCF)</label>
                                        <input formControlName="PaisPCF" name="PaisPCF" title="" class="form-control" id="PaisPCF" type="text" value="" [ngClass]="displayFieldCss('PaisPCF')" readonly>
                                    </div>-->

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombrePIF">Nombre</label>
                                        <input formControlName="NombrePIF" name="NombrePIF" title="" class="form-control" id="NombrePIF" type="text" value="" [ngClass]="displayFieldCss('NombrePIF')" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisPIF">País</label>
                                        <input formControlName="PaisPIF" name="PaisPIF" title="" class="form-control" id="PaisPIF" type="text" value="" [ngClass]="displayFieldCss('PaisPIF')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Operador-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedOperador = !isCollapsedOperador" [attr.aria-expanded]="!isCollapsedOperador" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Operador
                                <i *ngIf="isCollapsedOperador" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedOperador" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedOperador" [ngbCollapse]="isCollapsedOperador">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombreOperador">Nombre</label>
                                        <input formControlName="NombreOperador" name="NombreOperador" title="" class="form-control" id="NombreOperador" type="text" value="" [ngClass]="displayFieldCss('NombreOperador')" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisOperador">País</label>
                                        <input formControlName="PaisOperador" name="PaisOperador" title="" class="form-control" id="PaisOperador" type="text" value="" [ngClass]="displayFieldCss('PaisOperador')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--Documentos de acompañamiento-->
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDocAcomp = !isCollapsedDocAcomp" [attr.aria-expanded]="!isCollapsedDocAcomp" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Documentos de acompañamiento
                                <!--<i *ngIf="isCollapsedDocAcomp" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDocAcomp" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true"
                                     [value]="tracesParteI?.Documentos"
                                     [columns]="colsDocumentos" sortField="Nombre" sortOrder="1"
                                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                     [ngClass]="displayGridHidden(tracesParteI?.Documentos)">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">
                                                {{rowData[col.field]}}
                                            </span>

                                            <div *ngIf="col.field==='Link' && rowData['DownloadButtonAvailable'] !== false" class="btn-group">
                                                <button (click)="onDownload(rowData)" type="button" class="btn btn-sm btn-secondary" title="Descargar documento">
                                                    <span class="fa fa-download"></span>
                                                </button>
                                            </div>
                                            <span *ngIf="col.field==='Fecha'">
                                                {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroDocumentos === 0" class="empty-grid">
                                {{ isRechazo ? 'No hay documentos asociados al rechazo' : 'No hay documentos asociados al traslado' }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--Notificación previa-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedNotPrev = !isCollapsedNotPrev" [attr.aria-expanded]="!isCollapsedNotPrev" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Notificación previa
                                <i *ngIf="isCollapsedNotPrev" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedNotPrev" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedNotPrev" [ngbCollapse]="isCollapsedNotPrev">
                                <div class="row">

                                    <div class="form-group col-md-12">
                                        <div *ngIf="dateToString === '0001-01-01T00:00:00'">
                                            <label class="col-form-label" for="NotificacionPrevia">Notificación previa</label>
                                            <input title="" class="form-control" id="NotPrev" type="text" value="" [ngClass]="displayFieldCss('NotificacionPrevia')" readonly>
                                        </div>
                                        <div *ngIf="dateToString !== '0001-01-01T00:00:00'">
                                            <label class="col-form-label" for="NotificacionPrevia">Notificación previa</label>
                                            <input formControlName="NotificacionPrevia" name="NotificacionPrevia" title="" class="form-control" id="NotPrev" type="text" value="" [ngClass]="displayFieldCss('NotificacionPrevia')" readonly>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Lugar de destino-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedLugarDestino = !isCollapsedLugarDestino" [attr.aria-expanded]="!isCollapsedLugarDestino" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Lugar de destino
                                <i *ngIf="isCollapsedLugarDestino" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedLugarDestino" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedLugarDestino" [ngbCollapse]="isCollapsedLugarDestino">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombreLugarDestino">Nombre</label>
                                        <input formControlName="NombreLugarDestino" name="NombreLugarDestino" title="" class="form-control" id="NombreLugarDestino" type="text" value="" [ngClass]="displayFieldCss('NombreLugarDestino')" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisLugarDestino">País</label>
                                        <input formControlName="PaisLugarDestino" name="PaisLugarDestino" title="" class="form-control" id="PaisLugarDestino" type="text" value="" [ngClass]="displayFieldCss('PaisLugarDestino')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--Medio de transporte-->
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedMedioTrans = !isCollapsedMedioTrans" [attr.aria-expanded]="!isCollapsedMedioTrans" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Medio de transporte
                                <i *ngIf="isCollapsedMedioTrans" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedMedioTrans" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedMedioTrans" [ngbCollapse]="isCollapsedMedioTrans">
                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="TipoMedioTrans">Tipo</label>
                                        <input formControlName="TipoMedioTrans" name="TipoMedioTrans" title="" class="form-control" id="TipoMedioTrans" type="text" value="" [ngClass]="displayFieldCss('TipoMedioTrans')" readonly>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="NombreMedioTrans">Buque</label>
                                        <input formControlName="NombreMedioTrans" name="NombreMedioTrans" title="" class="form-control" id="NombreMedioTrans" type="text" value="" [ngClass]="displayFieldCss('NombreMedioTrans')" readonly>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="PaisMedioTrans">País</label>
                                        <input formControlName="PaisMedioTrans" name="PaisMedioTrans" title="" class="form-control" id="PaisMedioTrans" type="text" value="" [ngClass]="displayFieldCss('PaisMedioTrans')" readonly>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="DocumentoMedioTrans">Documento</label>
                                        <input formControlName="DocumentoMedioTrans" name="DocumentoMedioTrans" title="" class="form-control" id="DocumentoMedioTrans" type="text" value="" [ngClass]="displayFieldCss('DocumentoMedioTrans')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">

                <!--País de origen-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedPaisOrigen = !isCollapsedPaisOrigen" [attr.aria-expanded]="!isCollapsedPaisOrigen" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> País de origen
                                <i *ngIf="isCollapsedPaisOrigen" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedPaisOrigen" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedPaisOrigen" [ngbCollapse]="isCollapsedPaisOrigen">
                                <div class="row">

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="PaisOrigen">País de origen</label>
                                        <input formControlName="PaisOrigen" name="PaisOrigen" title="" class="form-control" id="PaisOrigen" type="text" value="" [ngClass]="displayFieldCss('PaisOrigen')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--País de expedición-->
                <div class="col-md-3">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedPaisExpedicion = !isCollapsedPaisExpedicion" [attr.aria-expanded]="!isCollapsedPaisExpedicion" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> País de expedición
                                <i *ngIf="isCollapsedPaisExpedicion" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedPaisExpedicion" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedPaisExpedicion" [ngbCollapse]="isCollapsedPaisExpedicion">
                                <div class="row">

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="PaisExpedicion">País de expedición</label>
                                        <input formControlName="PaisExpedicion" name="PaisExpedicion" title="" class="form-control" id="PaisExpedicion" type="text" value="" [ngClass]="displayFieldCss('PaisExpedicion')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Finalidad-->
                <div class="col-md-3">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedFinalidad = !isCollapsedFinalidad" [attr.aria-expanded]="!isCollapsedFinalidad" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Finalidad
                                <i *ngIf="isCollapsedFinalidad" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedFinalidad" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedFinalidad" [ngbCollapse]="isCollapsedFinalidad">
                                <div class="row">

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="Finalidad">Finalidad</label>
                                        <input formControlName="Finalidad" name="Finalidad" title="" class="form-control" id="Finalidad" type="text" value="" [ngClass]="displayFieldCss('Finalidad')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



            <div class="row">
                <!--Número del contenedor-->
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedNumeroContenedor = !isCollapsedNumeroContenedor" [attr.aria-expanded]="!isCollapsedNumeroContenedor" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Número del contenedor
                                <i *ngIf="isCollapsedNumeroContenedor" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedNumeroContenedor" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedNumeroContenedor" [ngbCollapse]="isCollapsedNumeroContenedor">
                                <div class="row">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="NumeroContenedor">Número del contenedor</label>
                                        <input formControlName="NumeroContenedor" name="NumeroContenedor" title="" class="form-control" id="NumeroContenedor" type="text" value="" [ngClass]="displayFieldCss('NumeroContenedor')" readonly>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="NumeroPrecinto">Número del precinto</label>
                                        <input formControlName="NumeroPrecinto" name="NumeroPrecinto" title="" class="form-control" id="NumeroPrecinto" type="text" value="" [ngClass]="displayFieldCss('NumeroPrecinto')" readonly>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="PrecintoOficial">Precinto oficial</label>
                                        <input formControlName="PrecintoOficial" name="PrecintoOficial" title="" class="form-control" id="PrecintoOficial" type="text" value="" [ngClass]="displayFieldCss('PrecintoOficial')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--Materiales de embalaje-->
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedEmbalajes = !isCollapsedEmbalajes" [attr.aria-expanded]="!isCollapsedEmbalajes" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Materiales de embalaje
                                <!--<i *ngIf="isCollapsedEmbalajes" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedEmbalajes" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true"
                                     [value]="tracesParteI?.Embalajes"
                                     [columns]="colsEmbalajes" sortField="Taric" sortOrder="1"
                                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                     [ngClass]="displayGridHidden(tracesParteI?.Embalajes)">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="col.field!=='Peso' && col.field!=='Recuento'">{{rowData[col.field]}}</span>

                                            <span *ngIf="col.field==='Peso'">
                                                <div *ngIf="rowData['Peso'] === 0"></div>
                                                <div *ngIf="rowData['Peso'] !== 0">{{rowData['Peso']}} {{rowData['RetrievedUnitCodeWeight']}}</div>
                                            </span>

                                            <span *ngIf="col.field==='Recuento'">
                                                <div *ngIf="rowData['NumeroUnidades'] === 0"></div>
                                                <div *ngIf="rowData['NumeroUnidades'] !== 0">{{rowData['NumeroUnidades']}} {{rowData['RetrievedUnitCodeQuantity']}}</div>
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroEmbalajes === 0" class="empty-grid">
                                {{ isRechazo ? 'No hay embalajes asociados al rechazo' : 'No hay embalajes asociados al traslado' }}
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <!--Productos-->
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedProductos = !isCollapsedProductos" [attr.aria-expanded]="!isCollapsedProductos" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Productos
                                <!--<i *ngIf="isCollapsedProductos" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedProductos" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true"
                                     [value]="tracesParteI?.Productos"
                                     [columns]="colsProductos" sortField="Taric" sortOrder="1"
                                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                     [ngClass]="displayGridHidden(tracesParteI?.Productos)">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="col.field!=='Peso' && col.field!=='Volumen' && col.field!=='NumeroUnidades' && col.field!=='NumeroBultos'">{{rowData[col.field]}}</span>

                                            <span *ngIf="col.field==='Peso'">
                                                <div *ngIf="rowData['Peso'] === 0"></div>
                                                <div *ngIf="rowData['Peso'] !== 0">{{rowData['Peso']}} {{rowData['RetrievedUnitCodeWeight']}}</div>
                                            </span>

                                            <span *ngIf="col.field==='Volumen'">
                                                <div *ngIf="rowData['Volumen'] === 0"></div>
                                                <div *ngIf="rowData['Volumen'] !== 0">{{rowData['Volumen']}} {{rowData['RetrievedUnitCodeVolume']}}</div>
                                            </span>

                                            <span *ngIf="col.field==='NumeroUnidades'">
                                                <div *ngIf="rowData['NumeroUnidades'] === 0"></div>
                                                <div *ngIf="rowData['NumeroUnidades'] !== 0">{{rowData['NumeroUnidades']}} {{rowData['RetrievedUnitCodeQuantity']}}</div>
                                            </span>

                                            <span *ngIf="col.field==='NumeroBultos'">
                                                <div *ngIf="rowData['NumeroBultos'] === 0"></div>
                                                <div *ngIf="rowData['NumeroBultos'] !== 0">{{rowData[col.field]}}</div>
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroProductos === 0" class="empty-grid">
                                {{ isRechazo ? 'No hay productos asociados al rechazo' : 'No hay productos asociados al traslado' }}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
